module.exports = __webpack_public_path__ + "img/dgb.425cc3cf.svg";